import { Observable, tap } from "rxjs";
import { BrokerService } from "src/app/sse/broker.service";
import { SseEvents } from "src/app/sse/sse-events";
import { consoleGrouped } from "src/app/support/console";

type OptmisticSseOptions = {
  factories: Array<{
    event: SseEvents;
    payloadFactory?: ({
      args,
      response
    }: {
      args?: Array<any>;
      response?: any;
    }) => any;
  }>;
};

function DEFAULT_PAYLOAD_FACTORY(response: any) {
  return response;
}

export function OptmisticSse(options: OptmisticSseOptions) {
  return function (
    target: Object,
    key: string | symbol,
    descriptor: PropertyDescriptor
  ) {
    return descriptor;

    /*
    const originalValue: (...args: any[]) => Observable<any> = descriptor.value;

    descriptor.value = function (...args: any[]) {
      let originalObs: Observable<any> | Promise<any> = originalValue.apply(
        this,
        args
      );

      const piped = originalObs.pipe(
        tap((value) => {
          options.factories.forEach(({ event, payloadFactory }) => {
            const payload = payloadFactory
              ? payloadFactory({ args, response: value })
              : DEFAULT_PAYLOAD_FACTORY(value);

            const msg = {
              event,
              isOptmistic: true,
              data: JSON.stringify(payload)
            };

            consoleGrouped(`[OPT-SSE] onmessage "${event}"`, () => ({
              ...msg,
              data: payload
            }));

            BrokerService.instance?.publish(msg);
          });
        })
      );

      return piped;
    };

    return descriptor;
    */
  };
}
